import { render, staticRenderFns } from "./addPallet.vue?vue&type=template&id=525c7650&"
import script from "./addPallet.vue?vue&type=script&lang=js&"
export * from "./addPallet.vue?vue&type=script&lang=js&"
import style0 from "./addPallet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports